import type { IConfigAPI } from '@monofe/util';
import {
    injectAuthManager,
    injectMediaManager,
    injectUserStateManager,
} from '../../controller/interface/bind';
import { injectWorkspaceDB } from '../../db/interface/bind';
import { IConfigAPIRequired, injectConfigAPI } from '../../interface/config';
import type { IContainer } from '../../interface/container';
import type { ISessionArgs, ISessionInstantiator } from '../interface/session';
import sessionInst from './session';

function _isConfigAPI(object: Partial<IConfigAPI> | undefined): object is Required<IConfigAPI> {
    return object &&
        object.url &&
        object.auth?.clientId &&
        object.auth?.clientSecret &&
        object.auth?.grantType &&
        object.auth?.password &&
        object.auth?.username &&
        object.extension?.auth &&
        object.extension?.media &&
        object.extension?.mediaDiff &&
        object.extension?.mediaWithAccessToken &&
        object.extension?.siteData
        ? true
        : false;
}

function _configAPI(container: IContainer): IConfigAPIRequired {
    const configAPI = injectConfigAPI(container);

    const config: IConfigAPIRequired | undefined = configAPI.filter(config =>
        _isConfigAPI(config),
    )[0] as IConfigAPIRequired | undefined;

    if (!config) {
        throw new Error(`No valid config-api found, ${JSON.stringify(configAPI)}`);
    }

    return config;
}

function session(container: IContainer): ISessionInstantiator {
    const authInst = injectAuthManager(container);
    const mediaInst = injectMediaManager(container);
    const userInst = injectUserStateManager(container);
    const dbInst = injectWorkspaceDB(container);
    const configAPI = _configAPI(container);

    const session: ISessionInstantiator = {
        ...sessionInst,
        open: (name: string, args?: ISessionArgs) =>
            sessionInst.open(configAPI, authInst, mediaInst, userInst, dbInst, name, args),
        exists: (name: string) => sessionInst.exists(name),
    };

    return session;
}

export default session;
